import { createContext, useContext } from 'react'
import useUnreadSupportCounter from '../../hooks/support/useUnreadSupportCounter'

type SupportCounterContextType = {
  supportCounter: number
}

export const SupportCounterContext = createContext<
  SupportCounterContextType | undefined
>(undefined)

export const useSupportCounterContext = () => {
  const context = useContext(SupportCounterContext)

  if (context === undefined) {
    throw new Error(
      'useSupportCounterContext must be used within a SupportCounterContextProvider'
    )
  }

  return context
}

type SupportCounterContextProviderProps = {
  children: React.ReactNode
}

export const SupportCounterContextProvider = ({
  children,
}: SupportCounterContextProviderProps) => {
  const { supportCounter } = useUnreadSupportCounter()

  return (
    <SupportCounterContext.Provider value={{ supportCounter }}>
      {children}
    </SupportCounterContext.Provider>
  )
}
